// extracted by mini-css-extract-plugin
module.exports = {"burgerMap":"Map_burgerMap__HYVeb","fixedPopup":"Map_fixedPopup__2N5SI"};